<template>
    <div class="add-subtags-container">
        <div class="wrapper">
            <h3>
                Create Subtags
            </h3>

            <subtag-form
                v-for="(tag,index) in subtags"
                :key="subtags[index].id"
                :id="subtags[index].id"
                :tagname="subtags[index].tagname"
                :image="subtags[index].image"
                :progress="subtags[index].progress"
                :loading="subtags[index].loading"
                :serverName="subtags[index].serverName"
                @remove="removeTag(index)"
                @input-title="subtags[index].tagname = $event.tagname"
                @input-image="handleTempUpload($event)"
                @warning="toggleWarning($event)"
            ></subtag-form>

            <div class="controls">
                <a
                    class="_approve"
                    @click.prevent="addSubtagForm"
                >
                    + Add New
                </a>

                <button
                    @click="save()"
                    class="btn-secondary"
                    :disabled="buttonLoading"
                >
                    Save
                </button>
            </div>
        </div>

    </div>
</template>

<script>
import SubtagForm from '@/components/newsfeed/SubtagForm.vue'

export default {
	data () {
		return {
			warningMessage: '',
			subtags: [{
				id: Math.floor(1000 + Math.random() * 9000),
				tagname: '',
				image: null,
				progress: 0,
				loading: false,
				serverName: null
			}],
			buttonLoading: false
		}
	},

	methods: {
		removeTag (index) {
			console.log('zxczx12')
			if (this.subtags.length > 1) {
				this.subtags.splice(index, 1)
			}
		},

		addSubtagForm () {
			this.subtags.push({
				id: Math.floor(1000 + Math.random() * 9000),
				tagname: '',
				image: null,
				progress: 0,
				loading: false,
				serverName: null
			})
		}
	},

	components: {
		SubtagForm
	}
}
</script>

<style lang="scss" scoped>
.add-subtags-container  {
    .wrapper {
        width: 100%;
        max-width: 800px;
        padding: 20px 40px;
        background-color: #fff;

        @include flex-column;

        h3 {
            padding-bottom: 20px;
            border-bottom: 2px solid $light;
            margin-bottom: 20px;
        }

        .controls {
            @include flex-row(space-between, center);

            a {
                font-size: 16px;
                display: inline-block;
                padding: 5px 0;
                color: $success;
                font-weight: 600;
                transition: 0.3s;
                cursor: pointer;
                border-bottom: 1px solid #fff;

                &:hover {
                    border-color: $success;
                }

                &.disabled {
                    opacity: 0.5;
                    pointer-events: none;
                }
            }

            button {
                width: 100px;
            }
        }

        .subtag-form {
            margin-bottom: 20px;
        }
    }
}
</style>
